<template>
  <div class="page-wrapper">
    <div class="layout-content">
      <route-view></route-view>
    </div>
    <layout-footer :menus="tabbarItems"></layout-footer>
  </div>
</template>

<script>
import RouteView from '@/components/layouts/RouteView'
import LayoutFooter from '@/components/page/LayoutFooter'
export default {
  name: 'MainLayout',
  components: { RouteView, LayoutFooter },
  data () {
    return {
      active: 0,
      tabbarItems: [
        { title: '首页', path: '/home', icon: 'home-o' },
        // { title: '关于', path: '/about', active: 'https://img01.yzcdn.cn/vant/user-active.png', inactive: 'https://img01.yzcdn.cn/vant/user-inactive.png' },
        { title: '我的', path: '/mine', icon: 'friends-o' }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
  .layout-content{
    height: calc(100vh - 100px);
    overflow: auto;
  }
</style>
